import {isPlatformBrowser, CommonModule} from '@angular/common';
import {GlobalServiceService} from "./../../shared/services/global-service.service";
import {HomeService} from "./../../shared/services/home.service";
import {Component, Inject, Input, OnInit, PLATFORM_ID} from "@angular/core";
import {ActivatedRoute, Router, RouterModule} from "@angular/router";
import {environment} from '../../../environments/environment.prod';
import { SweetAlert } from './../../shared/sweet-alert';

let swal = SweetAlert.swal;
let sweetAlert = SweetAlert.swal;

@Component({
    selector: "dc-global-header",
    templateUrl: "./global-header.component.html",
    styleUrls: ["./global-header.component.css"],
    standalone: true,
    imports: [CommonModule, RouterModule]
})

export class GlobalHeaderComponent implements OnInit {

  @Input() user;
  mobile: any;
  username: any;
  user_profile_pics;
  showRefresh
  curr_state;
  is_front_logged;
  is_switch_acc;
  loginType;
  logged_user_email;
  public logged_user_name;
  base_url;
  paidPlanExist = 0;
  mydentistid
  mydentistname
  welcomemsg
    private localStorage: Storage = {
    getItem: () => "",
    setItem: () => null,
    removeItem: () => null,
    clear: () => null,
    length: 0,
    key: () => null,
  } satisfies Storage;
  private window: Window;

  constructor(
    private activatedRoute: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object,
    private global: GlobalServiceService,
    private home: HomeService,
    private router: Router,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.window = window;
      this.localStorage = window.localStorage;
    }
  }

  ngOnInit() {
    if ( typeof localStorage !== "undefined" && localStorage?.getItem('dentist_id')) {
      var data = {
        id: Number( typeof localStorage !== "undefined" && localStorage?.getItem('dentist_id'))
      }
      this.home.isDentistAccountUnderReview(data).subscribe(x=> {
        if (x) {
          let data: any[] = x as [];
          if (data.length > 0) {
            this.localStorage.setItem('doctor_review', data[0].is_active)
          }
        }
      });
    }
    this.showRefresh = 0
    this.base_url = environment.chatImageApiPath;
    setTimeout(() => {
      this.mydentistid = this.localStorage?.getItem("mydentistid");
      this.mydentistname = this.localStorage?.getItem("mydentistname");
      this.welcomemsg = this.localStorage?.getItem("welcomemsg");
      if(this.welcomemsg) {
        var n = this.welcomemsg.includes("Welcome");
        if(n){
          this.welcomemsg = this.welcomemsg.replace("Welcome", "Connected")
        }
      }
    }, 1000);

    if(this.localStorage?.getItem('dentist_profile_pic')){
      this.user_profile_pics = this.localStorage?.getItem('dentist_profile_pic');
    } else if(this.localStorage?.getItem('patientImage')){
      this.user_profile_pics = this.localStorage?.getItem('patientImage')
    } else {
      this.user_profile_pics = "no_image.jpg";
    }

    this.global.logged_user_name.subscribe(res => {
      this.logged_user_name = res;
    })

    this.global.curr_state.subscribe(res => {
      this.curr_state = res;
    });
    this.global.is_front_logged.subscribe(res => {
      this.is_front_logged = res;
    });
    this.global.is_switch_acc.subscribe(res => {
      this.is_switch_acc = res;
    });

    this.global.loginType.subscribe(res => {
      this.loginType = res;
    });

    this.global.logged_user_email.subscribe(res => {
      this.logged_user_email = res;
    });

    this.global.user_profile_pics.subscribe(res =>{
      this.user_profile_pics = res;
    })


    if(typeof this.user_profile_pics =="object"){
        this.user_profile_pics = 'no_image.jpg'
    }

    this.global.showRefresh.subscribe(res =>{
      this.showRefresh = res;
      if (res == 1) {
        const body = typeof document !== "undefined" && document.getElementsByTagName("body")[0];
        body.classList.add("stripheader");
        location.reload();
      } else {
        const body = typeof document !== "undefined" &&  document.getElementsByTagName("body")[0];
        body.classList?.remove("stripheader");
      }
    })

    this.global.paidPlanExist.subscribe(res => {
      this.paidPlanExist = res;
    })

    this.mobile = false;
    if (isPlatformBrowser(this.platformId)) {
      if (window.screen.width < 768) {
        // 768px portrait
        this.mobile = true;
      }
    }
  }

  upgradeToPremium() {
    this.localStorage.setItem('plan', String(31));
    this.localStorage.setItem('pricing_info_new', '1');
    this.router.navigate(['/pricing-package-selection']);
  }

  onErrorDefaultImage(evt) {
    evt.target.src =
      "../../../assets/images/uploads/patient_profile_image/no_image.jpg";
  }

  patientLogout() {
    this.global.patientLogout();
  }

  switchDentistToAgent() {
    this.global.switchDentistToAgent();
  }

  switchAgentToDentist() {
    this.global.switchAgentToDentist();
  }

  logout() {
    this.global.logout();
  }

  redirectTo(path) {
    this.router.navigate([path]);
  }

  loadRefresh(){
    location.reload();
  }

  redirectFromMessage() {
    //if (this.localStorage?.getItem('doctor_review') != undefined && this.localStorage?.getItem('doctor_review') != '0') {
      this.router.navigate(['/dentist/messages']);
    // } else {
    //   SweetAlert.swal("Oops!", "Your account is under review.", "info");
    // }
  }
}
